(() => {
  const VIDEO_SELECTOR = '.mocap-product-video-media video, [data-mocap-product-video] video, .product-media video';

  function forceContain(video) {
    if (!video || video.dataset.mocapContainReady === '1') return;
    video.dataset.mocapContainReady = '1';
    video.style.objectFit = 'contain';
    video.style.objectPosition = 'center center';
    video.style.backgroundColor = '#000';
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    // Re-apply after native fullscreen toggles, because Chrome can recalculate UA/player styles.
    const reapply = () => {
      video.style.objectFit = 'contain';
      video.style.objectPosition = 'center center';
      video.style.backgroundColor = '#000';
      document.body.classList.toggle('mocap-video-fullscreen-active', Boolean(document.fullscreenElement || document.webkitFullscreenElement));
    };

    video.addEventListener('fullscreenchange', reapply);
    video.addEventListener('webkitfullscreenchange', reapply);
    video.addEventListener('webkitbeginfullscreen', reapply);
    video.addEventListener('webkitendfullscreen', reapply);
    video.addEventListener('loadedmetadata', reapply, { once: false });
    reapply();
  }

  function scan() {
    document.querySelectorAll(VIDEO_SELECTOR).forEach(forceContain);
  }

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);

  const mo = new MutationObserver(scan);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
